/*geometry解析工具， 提供遍历geometry方法， 并带一个坐标转换函数*/
import proj4 from "proj4";

/**
 * 对geometry中每个坐标点进行遍历处理
 * @param geometry
 * @param call_back
 * @param options
 */
function geometry_forEach(geometry,call_back,options){
  handle_geometry(geometry,call_back,options)
}

/**
 * 坐标转换函数
 * @param geometry
 * @param from_proj 转换之前的坐标系
 * @param to_proj 转换之后的坐标系
 */
function coordinate_transformation(geometry,from_proj = "",to_proj = ""){
  /*默认转换之前是2000投影 38度带*/
  //from_proj = from_proj || "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=38500000 +y_0=0 +ellps=GRS80 +units=m +no_defs"
  /*默认转换之前是2000投影 39度带*/
//  from_proj = from_proj || "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=39500000 +y_0=0 +ellps=GRS80 +units=m +no_defs"
  /*默认转换后是经纬度坐标*/
//  to_proj = to_proj || 'EPSG:4326'/*"+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs"*/
  //to_proj = "+proj=longlat +ellps=GRS80 +no_defs"/*"+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs"*/
  handle_geometry(geometry,do_coordinate_transformation,{from_proj,to_proj})
}


/**
 * 执行坐标转换
 * @param lnglat [lng,lat]
 * @param from_proj 源坐标系
 * @param to_proj 目标坐标系
 * @returns {(*)[] | (*)[] | [*, *]}
 */
function do_coordinate_transformation(lnglat,{from_proj,to_proj}){
  from_proj = from_proj || get_cor(lnglat[0])
  /*默认转换后是经纬度坐标*/
  to_proj = to_proj || 'EPSG:4326'/*"+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs"*/
  let res = proj4(from_proj,to_proj,lnglat);
  lnglat[0] = res[0]
  lnglat[1] = res[1]
}

/**
 * 处理geometry
 * @param geometry geomrtry
 * @param call_back 回调函数
 * @param options 要给回调传的参数
 */
function handle_geometry(geometry,call_back,options){
  switch (geometry.type) {
    case 'Point':
      point_transformation(geometry,call_back,options);
      break
    case 'LineString':
      lineString_transformation(geometry,call_back,options);
      break
    case 'Polygon':
      polygon_transformation(geometry,call_back,options);
      break
    case 'MultiPoint':
      multiPoint_transformation(geometry,call_back,options);
      break
    case 'MultiLineString':
      multiLineString_transformation(geometry,call_back,options);
      break
    case 'MultiPolygon':
      multiPolygon_transformation(geometry,call_back,options);
      break
    case 'GeometryCollection':
      var ret = 'GEOMETRYCOLLECTION';
      for (var i = 0; i < geometry.geometries.length; i++){
        handle_geometry(geometry.geometries[i],call_back,options)
      }
      break
    default:
      throw Error ("Unknown Type: " + geometry.type);
  }
}


function point_transformation (primitive,call_back,options) {
  var ret = 'POINT ';

  if (primitive.coordinates === undefined || primitive.coordinates.length === 0) {
    ret += 'EMPTY';
    return ret;
  }
  itemToRing(primitive.coordinates,call_back,options)
}

function lineString_transformation (primitive,call_back,options) {
  var ret = 'LINESTRING ';
  if (primitive.coordinates === undefined || primitive.coordinates.length === 0 || primitive.coordinates[0].length === 0) {
    ret += 'EMPTY';
    return ret;
  }
  arrayToRing(primitive.coordinates,call_back,options);
}

function polygon_transformation(geometry,call_back,options) {
  var ret = 'POLYGON ';
  if (geometry.coordinates === undefined || geometry.coordinates.length === 0 || geometry.coordinates[0].length === 0) {
    return ret;
  }

  for(var i = 0 ; i < geometry.coordinates.length ;i++){
    arrayToRing(geometry.coordinates[i],call_back,options)
  }
}

function multiPoint_transformation (primitive,call_back,options) {
  var ret = 'MULTIPOINT ';
  if (primitive.coordinates === undefined || primitive.coordinates.length === 0 || primitive.coordinates[0].length === 0) {
    ret += 'EMPTY';
    return ret;
  }
  arrayToRing(primitive.coordinates,call_back,options);
}

function multiLineString_transformation (primitive,call_back,options) {
  var ret = 'MULTILINESTRING ';

  if (primitive.coordinates === undefined || primitive.coordinates.length === 0 || primitive.coordinates[0].length === 0) {
    ret += 'EMPTY';
    return ret;
  }

  for (var i = 0; i < primitive.coordinates.length; i++) {
    arrayToRing(primitive.coordinates[i],call_back,options)
  }

}

function multiPolygon_transformation (primitive,call_back,options) {
  var ret = 'MULTIPOLYGON ';

  if (primitive.coordinates === undefined || primitive.coordinates.length === 0 || primitive.coordinates[0].length === 0 || primitive.coordinates[0][0].length === 0) {
    ret += 'EMPTY';
    return ret;
  }

  for (var c = 0; c < primitive.coordinates.length; c++) {
    for (var i = 0; i < primitive.coordinates[c].length; i++) {
      arrayToRing(primitive.coordinates[c][i],call_back,options)
    }
  }
}

/*遍历数组，进行经纬度转2000坐标*/
function arrayToRing(arr,call_back,options) {
  for(var i = 0 ; i < arr.length ;i++){
    call_back(arr[i],options)
  }
}

function itemToRing(item,call_back,options) {
  call_back(item,options)
}

/**
 * 计算该坐标点应该使用什么源坐标系
 * @param point
 * @returns {string}
 */
function get_cor(point){

  /*2000坐标系 39度带*/
  let cor_2000_39 = "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=39500000 +y_0=0 +ellps=GRS80 +units=m +no_defs"
  /*2000坐标系 38度带*/
  let cor_2000_38 = "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=38500000 +y_0=0 +ellps=GRS80 +units=m +no_defs"

  /*最终要用的带号*//*默认转换之前是2000投影 39度带*/
  let final_cor_dai_hao = cor_2000_39
  /*带号*/
  let dai_hao = point.toString().substring(0,2)
  if(dai_hao == "38"){
    final_cor_dai_hao = cor_2000_38
  }
  if(dai_hao == "39"){
    final_cor_dai_hao = cor_2000_39
  }

  return final_cor_dai_hao
}

/*获取geometry的第一个坐标点*/
function get_first_coordinate(geometry){
  let res = ""
  if(geometry.type == "GeometryCollection"){alert("GeometryCollection")}

  switch (geometry.type) {
    case 'Point':
      return  res = point_first_point(geometry);
    case 'LineString':
      return res = lineString_first_point(geometry);
    case 'Polygon':
      return res = polygon_first_point(geometry);
    case 'MultiPoint':
      return res = multiPoint_first_point(geometry);
    case 'MultiLineString':
      return res = multiLineString_first_point(geometry);
    case 'MultiPolygon':
      return res = multiPolygon_first_point(geometry);
    case 'GeometryCollection':
      var ret = 'GEOMETRYCOLLECTION';
      return res = get_first_coordinate(geometry.geometries[0])
    default:
      throw Error ("Unknown Type: " + geometry.type);
  }

  return ("Unknown Type: " + geometry.type)

}

function point_first_point (primitive) {
  var ret = 'POINT ';

  if (primitive.coordinates === undefined || primitive.coordinates.length === 0) {
    ret += 'EMPTY';
    return ret;
  }
  return JSON.parse(JSON.stringify(primitive.coordinates))

}

function lineString_first_point (primitive) {
  var ret = 'LINESTRING ';

  if (primitive.coordinates === undefined || primitive.coordinates.length === 0 || primitive.coordinates[0].length === 0) {
    ret += 'EMPTY';

    return ret;
  }

  return JSON.parse(JSON.stringify(primitive.coordinates[0]))
}

function polygon_first_point(geometry) {
  var ret = 'POLYGON ';
  if (geometry.coordinates === undefined || geometry.coordinates.length === 0 || geometry.coordinates[0].length === 0) {
    return ret;
  }
  return  JSON.parse(JSON.stringify(geometry.coordinates[0][0]))
}

function multiPoint_first_point (primitive) {
  var ret = 'MULTIPOINT ';
  if (primitive.coordinates === undefined || primitive.coordinates.length === 0 || primitive.coordinates[0].length === 0) {
    ret += 'EMPTY';
    return ret;
  }

  return JSON.parse(JSON.stringify(primitive.coordinates[0]))
}

function multiLineString_first_point (primitive) {
  var ret = 'MULTILINESTRING ';

  if (primitive.coordinates === undefined || primitive.coordinates.length === 0 || primitive.coordinates[0].length === 0) {
    ret += 'EMPTY';
    return ret;
  }
  return JSON.parse(JSON.stringify(primitive.coordinates[0][0]))
}

function multiPolygon_first_point (primitive) {
  var ret = 'MULTIPOLYGON ';

  if (primitive.coordinates === undefined || primitive.coordinates.length === 0 || primitive.coordinates[0].length === 0 || primitive.coordinates[0][0].length === 0) {
    ret += 'EMPTY';
    return ret;
  }
  return JSON.parse(JSON.stringify(primitive.coordinates[0][0][0]))
}

/*feature坐标转换,如果判断为需要转换则进行转换*/
function coordinate_transform(feature,from_proj){
  if(feature instanceof Array){
    if(feature.length > 0){
      let res = this.geojson_tool.get_first_coordinate(feature[0].geometry,from_proj)
      /*如果feature第一个精度大于180，任务是2000都应坐标系，要做转换*/
      if(res[0] > 180 ){
        /*最终要用的带号*/
        for(let i = 0; i < feature.length ;i++){
          this.geojson_tool.coordinate_transformation(feature[i].geometry,from_proj)
        }
      }
    }
  }else{
    let res = this.geojson_tool.get_first_coordinate(feature.geometry,from_proj)
    if(res[0] > 180 ){
      this.geojson_tool.coordinate_transformation(feature.geometry,from_proj)
    }
  }
}

export default {
  coordinate_transformation,/*坐标系转换，（geometry,from_proj,to_proj） */
  get_first_coordinate,/*获取geometry的第一个点的坐标值*/
  geometry_forEach,/*提供解析geometry的函数， 该函数可以处理每一个geometry坐标点， （geometry,call_back,options）*/
  coordinate_transform,
}



// WEBPACK FOOTER //
// ./src/assets/js/global_tool/sys_tool/geojson_tool.js